// 业务需求是无台风和有台风做不同跳转
// import { getAuthStorage } from '@/api/service-localstorage'
export default [// {
//   path: '',
//   // redirect: '/disaster'
//   // redirect: function() {
//   //   if (getAuthStorage()) {
//   //     return {
//   //       path: '/tfjc'
//   //     }
//   //   } else {
//   //     return {
//   //       path: '/login'
//   //     }
//   //   }
//   // },
//   beforeEnter: function(to, from, next) {
//     console.log('9999', this)
//     next()
//   }
// },
{
  path: '/404-nofound',
  name: 'nofound',
  component: function component() {
    return import('@/views/nofound.vue');
  }
}, {
  path: '/login',
  name: 'login',
  component: function component() {
    return import('@/views/login');
  }
}];